import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TopicService from "../topic/TopicService";

export default function BrTabTopics({ bedrockIdeaId, onError }) {
    const navigate = useNavigate();
    const [topics, setTopics] = useState([]);
    const [loading, setLoading] = useState(false);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [totalRows, setTotalRows] = useState(0);

    useEffect(() => {
        if (!bedrockIdeaId) return;
        let cancelled = false;
        const fetchTopics = async () => {
            setLoading(true);
            const result = await TopicService.listTopics(
                paginationModel.page,
                paginationModel.pageSize,
                "createdAt:desc",
                { bedrockIdeaId }
            );
            setLoading(false);
            if (cancelled) return;
            if (result.success && result.data) {
                setTopics(result.data.content || []);
                setTotalRows(result.data.page?.totalElements ?? 0);
            } else if (onError) {
                onError("error", result.error || "Failed to fetch topics");
            }
        };
        fetchTopics();
        return () => { cancelled = true; };
    }, [bedrockIdeaId, paginationModel.page, paginationModel.pageSize]);

    if (!bedrockIdeaId) return null;

    return (
        <Box sx={{ mt: 2 }}>
            <DataGrid
                rows={topics}
                columns={[
                    { field: "title", headerName: "Title", flex: 1, minWidth: 200 },
                    {
                        field: "relatedWords",
                        headerName: "Related Words",
                        flex: 1,
                        minWidth: 180,
                        valueGetter: (value) => (value != null ? String(value) : "")
                    },
                    {
                        field: "formattedDate",
                        headerName: "Date",
                        width: 140
                    },
                    {
                        field: "tags",
                        headerName: "Tags",
                        flex: 1,
                        minWidth: 150,
                        valueGetter: (value) =>
                            value && Array.isArray(value) ? value.join(", ") : ""
                    },
                    {
                        field: "difficultyLevel",
                        headerName: "Difficulty",
                        width: 100,
                        valueGetter: (value) => (value != null ? String(value) : "")
                    }
                ]}
                getRowId={(row) => row.id}
                loading={loading}
                paginationMode="server"
                rowCount={totalRows}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[10, 25, 50]}
                onRowClick={(params) =>
                    navigate(`/admin/topic/detail/${params.id}`, {
                        state: { returnTo: `/admin/bedrock-idea/edit/${bedrockIdeaId}` }
                    })
                }
                autoHeight
                sx={{ minHeight: 400, "& .MuiDataGrid-row": { cursor: "pointer" } }}
            />
        </Box>
    );
}
